export default __webpack_public_path__ + "images/406802034322e97929cf1e5c16979c40.png";